import React, {Component} from 'react';

class TransportStep extends Component {
  render() {
    return (
      <div>
          <h1> This is TransportStep </h1>
      </div>
    )
  }
}

export default TransportStep;